<script setup>
import { computed, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();

defineProps({
  shortList: {
    type: Boolean,
    default: false
  }
});

const allMathes = computed(() => {
  if (
    !Array.isArray(proxy.$stores.match.state?.pronostics?.list?.[0]?.dayMatches)
  )
    return [];
  let all = [];
  proxy.$stores.match.state?.pronostics?.list?.[0]?.dayMatches?.forEach((c) => {
    all.push(...c.matches);
  });
  return all;
});

const loading = computed(() => proxy.$stores.match.state?.pronostics?.loading);
</script>

<style scoped>
.shimmerElement {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>

<template>
  <div class="">
    <VBusHelper :emitOnMounted="$constants.EVENTS.MATCH.PRONOSTICS.REFRESH" />
    <!-- {{ $stores.match.state.pronostics.list?.length }} -->

    <!-- Shimmer loading -->
    <div
      v-if="loading"
      class="flex gap-4"
      :class="{ 'flex-col gap-8!': !shortList }"
    >
      <div
        v-for="i in shortList ? 2 : 4"
        :key="`shimmer-${i}`"
        class="min-w-[70vw]"
      >
        <div class="shimmerElement h-48 rounded-2xl" />
      </div>
    </div>

    <div
      v-else-if="allMathes?.length > 0"
      class="flex gap-4"
      :class="{ 'flex-col gap-8!': !shortList }"
    >
      <div
        v-for="(match, matchIndex) in shortList
          ? allMathes.slice(0, 4)
          : allMathes"
      >
        <div class="min-w-[70vw] h-full">
          <MatchPronosticPresentation :key="matchIndex" :match="match" />
        </div>
      </div>
    </div>

    <!-- Message pour les jours sans match -->
    <div v-else class="px-4 !hidden">
      <div
        class="rounded-3xl border-2 border-dashed border-gray-300 bg-gray-50/30 p-12 text-center"
      >
        <div class="flex flex-col items-center justify-center space-y-4">
          <!-- Icône de calendrier ou match -->
          <div
            class="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center"
          >
            <svg
              class="w-8 h-8 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>

          <!-- Texte explicatif -->
          <div class="space-y-2">
            <h3 class="text-lg font-semibold text-gray-700">
              Aucun match ce jour
            </h3>
            <p class="text-gray-500 text-sm max-w-xs mx-auto">
              Les compétitions reprennent demain avec de nouveaux affrontements
              passionnants !
            </p>
          </div>

          <!-- Indicateur visuel -->
          <div class="flex items-center space-x-2 text-xs text-gray-400">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>Journée de repos</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
